import { phiBooleanTypePolicy, phiNumberTypePolicy, phiStringTypePolicy } from "./phi-scalar-type-policies";

export const scalarTypePolicies = {
  CaregiverTravelDistance: {
    fields: {
      phiEstimatedTravelDistanceInMinutesByTransit: phiNumberTypePolicy,
      phiEstimatedTravelDistanceInMinutesByCar: phiNumberTypePolicy,
    },
  },
  PHIAddress: {
    fields: {
      addressLine1: phiStringTypePolicy,
      addressLine2: phiStringTypePolicy,
      city: phiStringTypePolicy,
      zip5: phiStringTypePolicy,
    },
  },
  PHIAgentTimelineItemAction: { fields: { phiLLMShortDescription: phiStringTypePolicy } },
  PHIAgentTimelineItemEscalation: { fields: { phiEscalationMessage: phiStringTypePolicy } },
  PHIAgentTimelineItemPrompt: { fields: { phiPrompt: phiStringTypePolicy } },
  PHIAgentTimelineItemWaiting: { fields: { phiLLMReasonForWaiting: phiStringTypePolicy } },
  PHICaregiverShiftPostingBroadcastCallResult: { fields: { phiSummary: phiStringTypePolicy } },
  PHICaregiverShiftPostingMatchContext: { fields: { phiWorkedWithPatient: phiBooleanTypePolicy } },
  PHICaregiverShiftPostingMatchFactorScoreAndWeights: {
    fields: {
      phiFactorName: phiStringTypePolicy,
      phiOriginalFactorWeight: phiNumberTypePolicy,
      phiNormalizedFactorWeight: phiNumberTypePolicy,
      phiOriginalFactorScore: phiNumberTypePolicy,
      phiNormalizedFactorScore: phiNumberTypePolicy,
    },
  },
  PHICaregiverShiftPostingMatchFactors: {
    fields: {
      phiWorkedWithPatient: phiBooleanTypePolicy,
      phiTravelDistanceInMinutes: phiNumberTypePolicy,
      phiTravelDistanceFromHomeInMinutes: phiNumberTypePolicy,
      phiClosestDistanceFromClosestShift: phiNumberTypePolicy,
    },
  },
  PHICaregiverTravelDistanceFromWorkToSoonestShift: { fields: { phiDistanceInMinutes: phiNumberTypePolicy } },
  PHICaregiverVoiceCallback: { fields: { phiDescriptionContext: phiStringTypePolicy } },
  PHIDistanceEstimateRange: { fields: { minInMinutes: phiNumberTypePolicy, maxInMinutes: phiNumberTypePolicy } },
  PHIPatient: {
    fields: {
      phiPatientId: phiStringTypePolicy,
      phiFirstName: phiStringTypePolicy,
      phiLastName: phiStringTypePolicy,
      phiGender: phiStringTypePolicy,
      phiZipCode: phiStringTypePolicy,
      phiPreferredCaregiverLanguage: phiStringTypePolicy,
      phiAlerts: phiStringTypePolicy,
      phiHasDogs: phiBooleanTypePolicy,
      phiHasCats: phiBooleanTypePolicy,
      phiIsBedBound: phiBooleanTypePolicy,
      phiLinkToPatientInSchedulingSystem: phiStringTypePolicy,
    },
  },
  PHIPatientForCaregiver: {
    fields: {
      phiPatientId: phiStringTypePolicy,
      phiFirstName: phiStringTypePolicy,
      phiLastName: phiStringTypePolicy,
      phiHasDogs: phiBooleanTypePolicy,
      phiHasCats: phiBooleanTypePolicy,
    },
  },
  PHIPatientWeight: { fields: { amount: phiNumberTypePolicy } },
  PHIShiftCaregiverSummary: {
    fields: { phiPatientFirstName: phiStringTypePolicy, phiPatientLastName: phiStringTypePolicy },
  },
  PHIVoiceConversationMessage: { fields: { phiMessage: phiStringTypePolicy } },
  PHIVoiceConversationRecordingTemporaryDownloadLink: { fields: { phiTemporaryDownloadLink: phiStringTypePolicy } },
  ResyncShiftsForPHIPatientsResult: { fields: { phiPatientId: phiStringTypePolicy } },
  Visit: { fields: { phiLinkToVisitInSchedulingSystemV2: phiStringTypePolicy } },
};
